// CBJJ/IBJJF belt graduation age rules — mirror of backend belt_age_rules.py
// The "year age" concept: someone who turns 16 during the current year
// qualifies for an adult belt even if currently 15 in days.

export const BELT_AGE_RULES = {
  Branca: { min: 4, max: null },
  // FASE D — as 8 faixas infantis COM BARRA usam os MESMOS limites da sua cor
  // (nenhum valor novo; nada mudou nas faixas que já existiam).
  'Cinza & Branca': { min: 4, max: 15 },
  Cinza: { min: 4, max: 15 },
  'Cinza & Preta': { min: 4, max: 15 },
  'Amarela & Branca': { min: 6, max: 15 },
  Amarela: { min: 6, max: 15 },
  'Amarela & Preta': { min: 6, max: 15 },
  'Laranja & Branca': { min: 10, max: 15 },
  Laranja: { min: 10, max: 15 },
  'Laranja & Preta': { min: 10, max: 15 },
  'Verde e Branca': { min: 13, max: 15 },
  Verde: { min: 13, max: 15 },
  'Verde e Preta': { min: 13, max: 15 },
  Azul: { min: 16, max: null },
  Roxa: { min: 16, max: null },
  Marrom: { min: 18, max: null },
  Preta: { min: 19, max: null },
  Coral: { min: 50, max: null },
  'Coral Preta e Vermelha': { min: 50, max: null },
  'Coral Branca e Vermelha': { min: 57, max: null },
  Vermelha: { min: 67, max: null },
};

export function yearAgeFrom(birthDate) {
  if (!birthDate) return null;
  const d = new Date(birthDate);
  if (Number.isNaN(d.getTime())) return null;
  return new Date().getFullYear() - d.getFullYear();
}

/** Returns { valid: bool, reason?: string } */
export function isBeltValidForBirthDate(beltName, birthDate) {
  if (!beltName || !birthDate) return { valid: true };
  const rule = BELT_AGE_RULES[(beltName || '').trim()];
  if (!rule) return { valid: true };
  const age = yearAgeFrom(birthDate);
  if (age === null) return { valid: true };
  if (rule.min && age < rule.min) {
    return { valid: false, reason: `Faixa ${beltName} exige no mínimo ${rule.min} anos no ano (atleta tem ${age}).` };
  }
  if (rule.max && age > rule.max) {
    return { valid: false, reason: `Faixa ${beltName} é até ${rule.max} anos (atleta tem ${age} no ano).` };
  }
  return { valid: true };
}

/** Returns the human-readable age range text for a belt: "Idade: 6 a 15 anos" etc. */
export function beltAgeRangeText(beltName) {
  const rule = BELT_AGE_RULES[(beltName || '').trim()];
  if (!rule) return '';
  if (rule.min && rule.max) return `Idade: ${rule.min} a ${rule.max} anos`;
  if (rule.min) return `Idade mínima: ${rule.min} anos`;
  if (rule.max) return `Idade máxima: ${rule.max} anos`;
  return '';
}

/** Filter a list of belt objects ({ _id, name }) leaving only those allowed for
 * the athlete's birth date. If birthDate is missing, returns the whole list. */
export function filterBeltsForBirthDate(belts, birthDate) {
  if (!birthDate) return belts;
  return belts.filter((b) => isBeltValidForBirthDate(b.name, birthDate).valid);
}
